// Problma -> En un campo de busqueda que filtra, cada tecla que apretas genera una request. -> Parametros por QueryString ?nombre="juan"&edad=&
// UseDebounce hace que la request se genere solo una vez. Despues de 500ms desde que terminas de escribir, evitando multiples request innecesarias.

/**
 * Metodo de uso:
 *
 * [searchTerm,setSearchTerm] = useState("");
 * const debouncedSearch = useDebounce(searchTerm,300 -> MS)
 */

import { useState, useEffect } from "react";

/**
 *
 * @param {String} value - Valor a "Debouncear"
 * @param {Number} delay [Delay = 500Ms] - Tiempo en milisegundos a esperar antes de actualizar
 * @returns {String} Valor debounced que se actualiza solo despues del delay especificado
 */
export const useDebounce = (value, delay = 500) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => clearTimeout(timer);
  }, [value, delay]);

  return debouncedValue;
};
